import React from 'react';
import ResultCount from './ResultCount';
import { generateComponentDocs, generateStoryDocs } from '../../utils/documentationUtils';

export default {
  title: 'Components/ResultCount',
  component: ResultCount,
  parameters: {
    layout: 'centered',

    ...generateComponentDocs(
      // What problem does it solve
      'Displays a consistent summary of the current page range and item totals for list-based pages.',
      // When and how to use it
      'Use this component anywhere a paginated list needs to show how many items are currently visible out of the total.',
      // Related components
      '\n- Used with pagination controls\n- Accepts dynamic labels via `pageType` prop for contextual messaging (e.g. "sites", "records", "results")\n',

    ),
  },
  tags: ['autodocs'],
};

const Template = (args) => <ResultCount {...args} />;

export const Default = Template.bind({});
Default.args = {
  offset: 0,
  pageSize: 20,
  total: 150,
  unfilteredTotal: 150,
  viewType: 'table',
  pageType: 'sites',
};
Default.parameters = generateStoryDocs(
  'Used when showing the first page of a full item list.',
  'Commonly used on index pages such as Sites, Routes, Visits, Notes, Contacts, and Tags.',
);

export const FilteredResults = Template.bind({});
FilteredResults.args = {
  offset: 20,
  pageSize: 20,
  total: 35,
  unfilteredTotal: 150,
  viewType: 'table',
  pageType: 'results',
};
FilteredResults.parameters = generateStoryDocs(
  'Used when search filters reduce the number of results displayed.',
  'Appears on any index page that supports filtering and pagination.',
);

export const LastPage = Template.bind({});
LastPage.args = {
  offset: 120,
  pageSize: 20,
  total: 135,
  unfilteredTotal: 135,
  viewType: 'table',
  pageType: 'records',
};
LastPage.parameters = generateStoryDocs(
  'Used when the user reaches the final page of a paginated list.',
  'Can be seen on any list page with enough data to reach later pages.',
);
